import React from 'react'

const Rotate = () => {
    return (
        <div className='container'>
            <h1>Rotate matrix by 90 degree</h1>
            <div className='containers'>
            Given a matrix. Rotate it by 90 degrees. <br />
<br />
For example if matrix arr[m][n] is <br />
<br />
<br />
<pre>{`
                          11   12   13   14 
                          21   22   23   24 
arr[m][n]=           31   32   33   34 
                         41   42    43   44 
                        `}</pre>
then print matrix like <br />
<br />
                        41  31  21  11 <br />
                        42  32  22  12 <br />
                        43  33  23  13 <br />
                        44  34  24  14 <br />

            </div>
            <div className='containers'>
         <code className='library'>#include</code>&lt;stdio.h&gt; <br/>
<code className='keywords'>int</code>  main()<br/>
&#123;<br/>
<code className='keywords'>int</code> matrix[100][100];<br/>
<code className='keywords'>int</code> m,n,i,j;<br/>
<code className='library'>printf</code>("Enter row and columns of matrix: ");<br/>
<code className='library'> scanf</code>("%d%d",&m,&n);<br/>
 <br/>
 <code className='comment'>/* Enter m*n array elements */</code><br/>
 <code className='library'> printf</code>("Enter matrix elements: \n");<br/>
 <code className='keywords'> for</code>(i=0;i&lt;m;i++)<br/>
 &#123;<br/>
 <code className='keywords'>  for</code>(j=0;j&lt;n;j++)<br/>
  &#123;<br/>
  <code className='library'>  scanf</code>("%d",&matrix[i][j]);<br/>
  &#125;<br/>
 &#125;<br/>
 <br/>
 <code className='comment'>/* matrix after the 90 degrees rotation */</code><br/>
 <code className='library'>printf</code>("Matrix after 90 degrees roration \n");<br/>
 <code className='keywords'> for</code>(i=0;i&lt;n;i++)<br/>
 &#123;<br/>
 <code className='keywords'></code> for(j=m-1;j&gt;=0;j--)<br/>
  &#123;<br/>
  <code className='library'>  printf</code>("%d  ",matrix[j][i]);<br/>
  &#125;<br/>
  <code className='library'> printf</code>("\n");<br/>
 &#125;<br/>
 <br/>
 <code className='library'>return</code> 0;<br/>
 <br/>
&#125;<br/>
<br/>
            </div>
        </div>
    )
}

export default Rotate
